import { render, staticRenderFns } from "./CreateContentBrechaComercial.vue?vue&type=template&id=619089e2&scoped=true"
import script from "./CreateContentBrechaComercial.vue?vue&type=script&lang=js"
export * from "./CreateContentBrechaComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619089e2",
  null
  
)

export default component.exports